/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VulnerabilityByRegionWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("VulnerabilityByRegionWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return VulnerabilityByRegionWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<VulnerabilityByRegionWidgetConfiguration>): VulnerabilityByRegionWidgetConfiguration {
        let obj = Object.assign(new VulnerabilityByRegionWidgetConfiguration(), model);
        VulnerabilityByRegionWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VulnerabilityByRegionWidgetConfiguration>): VulnerabilityByRegionWidgetConfiguration {
        if (!model) return null;
        return VulnerabilityByRegionWidgetConfiguration.newInstance(<VulnerabilityByRegionWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VulnerabilityByRegionWidgetConfiguration) {
        if (!obj) return;

        models.VulnerabilityByRegionWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VulnerabilityByRegionWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VulnerabilityByRegionWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
